import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { categories } from "@/mocks/events";

const navItems = [
  { label: "首页", to: "/" },
  { label: "赛事分类", to: "/events" },
  { label: "赛程安排", to: "/schedule" },
  { label: "新闻资讯", to: "/news" },
  { label: "关于我们", to: "/about" },
  { label: "联系我们", to: "/contact" },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [catOpen, setCatOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const submitSearch = (e?: React.FormEvent) => {
    e?.preventDefault();
    const q = keyword.trim();
    setMobileOpen(false);
    navigate(q ? `/events?q=${encodeURIComponent(q)}` : "/events");
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-label font-bold text-lg">
              51
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-semibold text-lg text-foreground-950 whitespace-nowrap">51每日大赛</span>
              <span className="hidden sm:block font-label text-[10px] tracking-[0.2em] text-foreground-500">DAILY ARENA</span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1 relative">
            {navItems.map((item) =>
              item.to === "/events" ? (
                <div
                  key={item.to}
                  className="relative"
                  onMouseEnter={() => setCatOpen(true)}
                  onMouseLeave={() => setCatOpen(false)}
                >
                  <NavLink
                    to={item.to}
                    className={({ isActive }) =>
                      `px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1 ${
                        isActive ? "text-primary-600 font-medium" : "text-foreground-700 hover:text-primary-600"
                      }`
                    }
                  >
                    {item.label}
                    <i className="ri-arrow-down-s-line text-base" />
                  </NavLink>
                  {catOpen ? (
                    <div className="absolute left-0 top-full pt-2 w-64">
                      <div className="rounded-lg border border-background-200 bg-background-50 p-2 grid grid-cols-2 gap-1">
                        {categories.map((c) => (
                          <Link
                            key={c.id}
                            to={`/category/${c.id}`}
                            className="flex items-center gap-2 px-2 py-2 rounded-md text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600 transition-colors"
                          >
                            <i className={`${c.icon} text-base text-primary-500`} />
                            {c.name}
                          </Link>
                        ))}
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    `px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                      isActive ? "text-primary-600 font-medium" : "text-foreground-700 hover:text-primary-600"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ),
            )}
          </nav>

          <form onSubmit={submitSearch} className="hidden md:flex items-center relative w-56 xl:w-64">
            <i className="ri-search-line absolute left-3 text-foreground-400 text-sm" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索赛事 / 队伍 / 选手"
              className="w-full h-9 pl-9 pr-3 text-sm rounded-full border border-background-300 bg-background-100 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:bg-background-50 transition-colors"
            />
          </form>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMobileOpen((v) => !v)}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
          >
            <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-xl`} />
          </button>
        </div>
      </div>

      {mobileOpen ? (
        <div className="lg:hidden border-t border-background-200 bg-background-50">
          <div className="px-4 py-4 space-y-4">
            <form onSubmit={submitSearch} className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索赛事 / 队伍 / 选手"
                className="w-full h-10 pl-9 pr-3 text-sm rounded-full border border-background-300 bg-background-100 focus:outline-none focus:border-primary-400"
              />
            </form>
            <div className="flex flex-col">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  onClick={() => setMobileOpen(false)}
                  className={({ isActive }) =>
                    `px-2 py-3 text-sm border-b border-background-100 ${
                      isActive ? "text-primary-600 font-medium" : "text-foreground-800"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
            <div>
              <div className="font-label text-xs tracking-widest text-foreground-500 mb-2">赛事分类</div>
              <div className="grid grid-cols-2 gap-2">
                {categories.map((c) => (
                  <Link
                    key={c.id}
                    to={`/category/${c.id}`}
                    onClick={() => setMobileOpen(false)}
                    className="flex items-center gap-2 px-3 py-2 rounded-md bg-background-100 text-sm text-foreground-700"
                  >
                    <i className={`${c.icon} text-base text-primary-500`} />
                    {c.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </header>
  );
}